import { QueryClient } from '@tanstack/react-query';
import { ApiRequestError } from './http';

/**
 * Không Redux, không Zustand — gần như mọi state trong ứng dụng này là dữ liệu
 * server, và Query lo cache/invalidate/retry tốt hơn (docs/frontend-guide.md §2).
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // 30 giây: đủ để chuyển tab qua lại không bắn lại query, đủ ngắn để
        // board Kanban không hiện dữ liệu cũ sau khi người khác vừa kéo thẻ.
        staleTime: 30_000,
        retry(failureCount, error) {
          // Retry lỗi phân quyền/validate là vô nghĩa — kết quả sẽ y hệt, chỉ
          // tổ làm người dùng chờ ba lần lâu hơn.
          if (error instanceof ApiRequestError && error.status < 500) return false;
          return failureCount < 2;
        },
      },
      mutations: {
        // Mutation KHÔNG retry mặc định: chưa có `Idempotency-Key`
        // (docs/api-conventions.md §9) thì thử lại có thể tạo hai bản ghi.
        retry: false,
      },
    },
  });
}
